import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components'
import classnames from 'classnames';
import Share from './icons/share-alt-regular.svg';
import ShareLight from './icons/share-alt-light.svg';
import Envelope from './icons/envelope-solid.svg';
import Facebook from './icons/facebook-f-brands.svg';
import LinkedIn from './icons/linkedin-in-brands.svg';
import Pinterest from './icons/pinterest-p-brands.svg';
import Tumblr from './icons/tumblr-brands.svg';
import Twitter from './icons/twitter-brands.svg';
import Instagram from './icons/instagram-brands.svg';

import SocialIconCSS from './social-icon.styles';

export const socialSites = [
  'share',
  'shareLight',
  'email',
  'facebook',
  'linkedin',
  'pinterest',
  'tumblr',
  'twitter',
  'instagram',
];

const iconForSite = (site) => {
  switch (site) {
    case 'share':
      return Share;
    case 'shareLight':
      return ShareLight;
    case 'email':
      return Envelope;
    case 'facebook':
      return Facebook;
    case 'linkedin':
      return LinkedIn;
    case 'pinterest':
      return Pinterest;
    case 'tumblr':
      return Tumblr;
    case 'twitter':
      return Twitter;
    case 'instagram':
      return Instagram;
    default:
      return () => null;
  }
};

/**
 * A Glowforge-standard icon representing the given social site. The general
 * approach is to use a field of the appropriate brand-color (e.g. facebook
 * blue, pinterest red) with a minimal logo bug over top. There are several
 * appearance variants provided:
 *
 * round - a round field dot
 * square - a square with rounded corners
 * clear - transparent background with the logo inheriting the current css
 *         `color`. This is useful for overlays.
 *
 * @param props
 * @param props.className - Applied to the div wrapping the svg
 * @param props.site - which social site?
 * @param props.size - standard sizes small, medium, or large
 * @param props.appearance - available styles square, round, clear
 * @returns {*}
 * @constructor
 */
const SocialIcon = ({
  className,
  site,
  size,
  appearance,
}) => {
  const Icon = iconForSite(site);

  return (
    <div className={classnames('SocialIcon', site, size, appearance, className)}>
      <Icon className='icon' />
    </div>
  );
};

SocialIcon.propTypes = {
  className: PropTypes.string,
  site: PropTypes.oneOf(socialSites).isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'fit']),
  appearance: PropTypes.oneOf(['square', 'round', 'clear']),
};

SocialIcon.defaultProps = {
  className: '',
  size: 'medium',
  appearance: 'square',
};

export default styled(SocialIcon)`
${SocialIconCSS}
`;
